import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';

/**
 * A wrapper around React Router's Route component for public routes.
 *
 * This component handles routes that should only be accessible to unauthenticated users:
 * - If user is NOT authenticated, renders the route normally
 * - If user IS authenticated and password is not expired, redirects to the start page with the current location saved in state
 *
 * Useful for pages like login, registration, password reset, or public landing pages
 * that should redirect already logged-in users to the application's main area.
 *
 * @param {Object} props - Component props
 * @param {React.ReactNode} props.children - The components to render when user is not authenticated
 * @param {Object} props.routeProps - Additional props to pass to the underlying Route component
 * @returns {React.ReactElement} A Route component with public route logic
 */
const PublicRoute = ({ children, ...routeProps }) => (
  <Route {...routeProps}>{children}</Route>
);

PublicRoute.propTypes = {
  children: PropTypes.node,
  routeProps: PropTypes.object,
};

export default PublicRoute;
